import React, { useEffect, useId, useRef, useState } from "react";
import "../../App.css";
import i18next from "../../i18n";
import ClickAwayListener from "react-click-away-listener";

function TeamMember({ data }) {
  const [showing, setShowing] = useState(false);
  const detailsId = useId();
  const nameId = useId();
  const triggerRef = useRef(null);
  const english = i18next.language.startsWith("en");
  const competence = english ? data.competenceEnglish : data.competence;
  const hasDetails = Boolean(competence?.length);
  const close = () => setShowing(false);
  useEffect(() => {
    if (!showing) return;
    const onEscape = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        setShowing(false);
        triggerRef.current?.focus();
      }
    };
    document.addEventListener("keydown", onEscape);
    return () => document.removeEventListener("keydown", onEscape);
  }, [showing]);
  const profile = (
    <>
      <span className="block w-full aspect-[3/4] overflow-hidden rounded-md bg-gray mb-2">
        <img className="w-full h-full object-cover object-center" src={data.image} alt="" />
      </span>
      <span id={nameId} className="block font-bold text-main-dark">{data.name}</span>
      <span className="flex justify-between text-base font-normal text-secondary">
        <span>{english ? data.roleEnglish : data.role}</span>
        {hasDetails && <span aria-hidden="true" className="ml-2">{showing ? "−" : "+"}</span>}
      </span>
    </>
  );

  return (
    <ClickAwayListener onClickAway={close}>
      <div className="relative flex flex-col justify-start text-left py-6 w-64">
        <h3 className="mb-0">
          {hasDetails ? (
            <button type="button" ref={triggerRef} aria-labelledby={nameId}
              aria-expanded={showing} aria-controls={detailsId}
              onClick={() => setShowing((previous) => !previous)}
              className="block w-full text-left rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main">
              {profile}
            </button>
          ) : profile}
        </h3>
        {hasDetails && (
          <div id={detailsId} hidden={!showing} className="text-main">
            <div className="relative bg-white z-40 shadow-xl p-6 rounded-md">
              {competence.map((section, i) => (
                <div key={i}>
                  {section.title && <div className="font-bold">{section.title}:</div>}
                  <ul className="list-disc list-outside ml-6 mb-2">
                    {section.things.map((item, j) => <li key={j}>{item}</li>)}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}

export default TeamMember;
